<template>
  <div>
    <div class="container position-sticky z-index-sticky top-0">
    <div class="row">
      <div class="col-12">
        <!-- Navbar -->
        <nav class="navbar navbar-expand-lg blur blur-rounded top-0 z-index-3 shadow position-absolute my-3 py-2 start-0 end-0 mx-4">
          <div class="container-fluid pe-0">
            <a class="navbar-brand font-weight-bolder ms-lg-0 ms-3 " href="login">
              <img src="../core_assets/img/sifvflogo.png" class="navbar-brand-img h-100" alt="main_logo">
            </a>
            <button class="navbar-toggler shadow-none ms-2" type="button" data-bs-toggle="collapse" data-bs-target="#navigation" aria-controls="navigation" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon mt-2">
                <span class="navbar-toggler-bar bar1"></span>
                <span class="navbar-toggler-bar bar2"></span>
                <span class="navbar-toggler-bar bar3"></span>
              </span>
            </button>
            <div class="collapse navbar-collapse" id="navigation">
              <ul class="navbar-nav mx-auto ms-xl-auto me-xl-7">
                <li class="nav-item">
                  <a class="nav-link me-2" href="login">
                    <i class="fas fa-key opacity-6 text-dark me-1"></i>
                    Inicio
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link me-2" href="login">
                    <i class="fas fa-key opacity-6 text-dark me-1"></i>
                    SIAC
                  </a>
                </li>
                
               
              </ul>
              
              <ul class="navbar-nav d-lg-block d-none">
               
              </ul>
            </div>
          </div>
        </nav>
        <!-- End Navbar -->
      </div>
    </div>
  </div>
   <main class="main-content  mt-0">
    <section>
      <div class="page-header min-vh-75">
        <div class="container">
          <div class="row">
            <div class="col-md-12 p-5 m-5 mx-auto">
              <div class="card card-plain mt-8">
                <div class="card-header pb-0 text-left bg-transparent">
                  <div class="row">
                    <div class="col-md-12 mx-auto p-5">
                      <h1 class="font-weight-bolder text-primary">Ops al parecer esta pagina no existe</h1>
                    </div>
                  </div>
                  
                 
                </div>
                <div class="card-body">
                 
                </div>
                <div class="card-footer text-center pt-0 px-lg-2 px-1">
                  <div class="text-center">
                      <button type="button" class="btn btn-primary w-100 mt-4 mb-0" @click="OnSubmit">Volver</button>
                    </div>
                </div>
              </div>
            </div>
            <div class="col-md-7">
             
              <div class="d-md-block d-none me-n8">
               
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
  <!-- -------- START FOOTER 3 w/ COMPANY DESCRIPTION WITH LINKS & SOCIAL ICONS & COPYRIGHT ------- -->
  <LayoutFooter></LayoutFooter>
</div>
</template>

<script>
import Swal from "sweetalert2";
import LayoutFooter from "./Auth/Layouts/Footer"
import { mapActions } from 'vuex'
export default {
  name: 'PageNotFound',
  components:{
    LayoutFooter
  },
  data() {
    return {
      model: {
        email: '',
        password: ''
      }
    }
  },
  methods: {
    ...mapActions(["login"]),

    OnSubmit() {
      this.$router.go(-1)
    }
  }
}
</script>
<style>
.gradient-custom-2 {
  /* fallback for old browsers */
  background: #fccb90;

  /* Chrome 10-25, Safari 5.1-6 */
  background: -webkit-linear-gradient(to right, #ee7724, #d8363a, #dd3675, #b44593);

  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background: linear-gradient(to right, #ee7724, #d8363a, #dd3675, #b44593);
}

@media (min-width: 768px) {
  .gradient-form {
    height: 100vh !important;
  }
}

@media (min-width: 769px) {
  /* .gradient-custom-2 {
    border-top-right-radius: .3rem;
    border-bottom-right-radius: .3rem;
  } */
}
</style>